import Vue from 'vue'
import Router from 'vue-router'

// 首页
// import Home from '@/components/Home/index')
import Home from '@/components/Home/index'

// 产品中心
import ProductsCenter from '@/components/ProductsCenter/index'

// 解决方案
import Solution from '@/components/Solution/index'

import AboutUs from '@/components/AboutUs/index'

import JoinUs from '@/components/JoinUs/index'

import Login from '@/components/Login/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/productsCenter',
      name: 'ProductsCenter',
      component: ProductsCenter
    },
    {
      path: '/solution',
      name: 'Solution',
      component: Solution
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/joinUs',
      name: 'JoinUs',
      component: JoinUs
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js